import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, FormGroup, FormControl, Glyphicon, ControlLabel, InputGroup } from "react-bootstrap";
import { EXTENSION, FILE, FILE_MAX_SIZE, LINK, SIZE, TITLE_EN, TITLE_RU } from "../constants";
import FormControlLanguage from "../../../UI/FormControlLanguage";
import clone from "lodash.clonedeep";
import { availableTypes, initialFileModel } from "../models";

const MaterialsUpdateModal = (
    {
        show,
        editableMaterial,
        onSave,
        onUpdate,
        onClose,
    }
) => {
    const [model, setModel] = useState(null);
    const [error, setError] = useState('');
    const fileCreateInputRef = useRef(null);
    const fileMessage = (model?.file || model?.path)
        ? (model?.file?.name ?? model?.titleRu)
        : '* Не более 20 мб';

    useEffect(() => {
        setModel(editableMaterial ?? clone(initialFileModel));
    }, [editableMaterial]);

    const handleUploadFile = (file) => {
        if (file.size > FILE_MAX_SIZE) {
            setError('Файл превышает допустимый размер');

            return;
        }

        if (!availableTypes[file.type]) {
            setError('Неверный формат файла');

            return;
        }

        handleChangeModel({[FILE]: file});
    };

    const handleAddLink = (value) => {
        const link = value.trim();
        let extension = link.split('.').pop();

        if (!Object.values(availableTypes).includes(extension)) {
            extension = '';
        }

        handleChangeModel({
            [LINK]: link,
            [EXTENSION]: extension,
            [SIZE]: null,
        })
    }

    const handleChangeModel = (value) => {
        setModel({
            ...model,
            ...value,
        });
    };

    const handleSave = () => {
        if (!model?.link) {
            setError('Введите корректную ссылку на файл');

            return;
        }

        editableMaterial ? onUpdate(model) : onSave(model);
        handleClose();
    };

    const handleClose = () => {
        setModel(null);
        setError('');
        onClose();
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>{editableMaterial ? 'Редактировать материал' : 'Добавить материалы'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormGroup>
                    <ControlLabel>Название</ControlLabel>
                    <FormControlLanguage
                        type="text"
                        values={{
                            ru: model?.titleRu || '',
                            en: model?.titleEn || '',
                        }}
                        onChange={{
                            ru: (e) => handleChangeModel({[TITLE_RU]: e.target.value}),
                            en: (e) => handleChangeModel({[TITLE_EN]: e.target.value}),
                        }}
                    />
                </FormGroup>
                <FormGroup>
                    <FormControl
                        inputRef={ref => fileCreateInputRef.current = ref}
                        type="file"
                        onChange={(e) => {
                            setError('');
                            handleUploadFile(e.target.files[0])
                        }}
                        style={{display: 'none'}}
                    />
                    <Button
                        disabled={(!editableMaterial && !!model?.link) || !!model?.link}
                        onClick={() => fileCreateInputRef?.current?.click()}
                    >
                        <Glyphicon glyph="folder-open" />{' '}
                        Загрузить файл
                    </Button>
                    <span style={{marginLeft: '12px'}}>
                        {fileMessage}
                    </span>
                </FormGroup>
                <p style={{fontStyle: 'italic'}}>
                    * {Object.values(availableTypes).join(', ')}
                </p>
                <FormGroup>Или</FormGroup>
                <FormGroup>
                    <InputGroup>
                        <InputGroup.Addon>Добавить ссылку</InputGroup.Addon>
                        <FormControl
                            type="text"
                            value={model?.link ?? ''}
                            disabled={!!model?.file || !!model?.path}
                            onChange={(e) =>{
                                setError('');
                                setModel({...model, [LINK]: e.target.value});
                            }}
                            onBlur={() => handleAddLink(model?.link)}
                        />
                    </InputGroup>
                </FormGroup>
                {error && (
                    <p style={{color: '#FF121D'}}>
                        * {error}
                    </p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleSave} disabled={!model?.link && !model?.extension}>Сохранить</Button>
                <Button onClick={handleClose}>Отмена</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MaterialsUpdateModal;
